<template>
  <v-card 
    elevation="0"
    class="mb-6 activation-panel"
  >
    <v-card-text class="pa-6">
      <v-row align="center">
        <v-col cols="12" md="9">
          <h2 class="text-h6 font-weight-bold mb-2 black--text">
            <v-icon left color="grey darken-3">mdi-autorenew</v-icon>
            Modulo de Suscripciones
          </h2>
          <p class="text-body-2 text--secondary mb-0">
            Activa o desactiva el sistema de domiciliación bancaria para membresías.
          </p>
        </v-col>
      </v-row>
      
      <div class="mt-4 pa-4 border-billing">
        <div class="d-flex align-center justify-space-between">
          <div>
            <p class="text-body-2 mb-1 black--text">
              <strong>Suscripciones</strong>

              <v-chip 
                small 
                class="ml-2" 
                :color="value ? 'grey darken-3' : 'grey lighten-2'" 
                :text-color="value ? 'white' : 'grey darken-2'"
              >
                {{ value ? 'Activo' : 'Inactivo' }}
              </v-chip>
            </p>
            <p class="text-caption text--secondary mb-0">
              Permite cobros automáticos y gestión de pagos para membresías.
            </p>
          </div>
          <v-switch
            :value="value"
            color="grey darken-3"
            inset
            dense
            :loading="loading"
            :disabled="loading || activating"
            @change="$emit('input', $event)"
          ></v-switch>
        </div>
      </div>

      <!-- Nota sobre el costo adicional de usar billing -->
      <div class="mt-4 pa-4 border-billing white text-body-2">
        <v-icon class="mr-2" color="grey darken-2">mdi-information</v-icon>
        <strong>Nota:</strong> Al activar las suscripciones, se aplicará la comisión estándar 
        <strong class="black--text">(3.6% + 3 pesos + IVA)</strong> y un adicional de 0.7% + IVA sobre 
        cada transacción recurrente para cubrir los costos de procesamiento automático.
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'ActivationPanel',
  
  props: {
    value: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    activating: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.border-billing {
  border: 1px solid #c9c9c9;
  border-radius: 4px;
  background-color: transparent;
}

.activation-panel {
  border: 1px solid #acacac;
  border-radius: 8px;
}
</style>
